<div class="loading-overlay" [ngClass]="{ block: isVisible }" *ngIf="isVisible">
  <div class="loading-overlay__spinner"></div>
</div>
